import { SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { getProductListActions } from "@/App/actions";
import { ProductListTypes } from "@/types";

function* getProductList(data?: ProductListTypes.ProductListSearchOptions): Generator {
  return yield apiService({
    url: "/product_list/list",
    method: "POST",
    data: data || {},
  });
}

export function* getProductListWorker(action: ReturnType<typeof getProductListActions.getProductList>): SagaIterator {
  const { getProductListResults } = getProductListActions;
  const { showPageAlert } = PageAlert;
  const { payload } = action;

  try {
    const results = yield call(getProductList, payload);

    yield put(getProductListResults(results));
  } catch (error) {
    const { data: { message = "" } = {} } = error || {};
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* memberDocumentInformationWatcher(): SagaIterator {
  yield takeEvery(ActionTypes.GET_PRODUCT_LIST, getProductListWorker);
}
